<template>
  <v-card class="mb-4"
          v-if="team.content_enabled">
    <v-card-title>
      Access Control
    </v-card-title>
    <v-simple-table>
      <tbody>
      <tr v-if="!presentation.is_private">
        <td>
          Groups with access
        </td>
        <td>
          <v-list dense
                  v-if="presentation.groups.length"
                  class="py-0"
                  style="background: none;">
            <template v-for="group in presentation.groups">
              <v-list-item :key="group.id"
                           class="pl-0">
                <v-list-item-content>
                  {{ group.name }}
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="presentation.groups.length > 1"></v-divider>
            </template>
          </v-list>
          <v-chip color="warning"
                  label
                  small
                  v-else>
            None
          </v-chip>
        </td>
      </tr>
      <tr>
        <td>
          Visibility
        </td>
        <td>
          <template v-if="presentation.show_in_main_list && presentation.folders.length === 0">
            On the main screen.
          </template>
          <template v-if="presentation.show_in_main_list && presentation.folders.length">
            On the main screen and in selected folders.
          </template>
          <template v-if="!presentation.show_in_main_list && presentation.folders.length">
            In selected folders only.
          </template>
        </td>
      </tr>
      <tr v-if="presentation.folders.length">
        <td>
          In folders
        </td>
        <td>
          <v-list dense
                  class="py-0">
            <v-list-item v-for="folder in presentation.folders"
                         :key="folder.id">
              <v-list-item-icon class="mr-2">
                <v-icon>
                  fal fa-folder
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ folder.name }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </td>
      </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ])
  }
}
</script>
